





import Vue from 'vue'
import Component from "vue-class-component"
import {Ref} from "vue-property-decorator";
import {VueSignaturePad} from 'vue-signature-pad'
import { IOptions } from 'signature_pad'

@Component
export default class SignaturePad extends Vue {
    /**
     * Referencia al componente que controla zona de dibujo de la firma
     */
    @Ref()
    public signaturePad: VueSignaturePad
    public documento: string
    public importe: number

    public get options (): IOptions {
        return {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: 'rgb(5, 0, 0)',
            onEnd: () => {
                this.$emit('end', this.signaturePad.saveSignature('image/jpeg'))
            }
        }
    }

    public clear () {
        this.signaturePad.clearSignature()

        this.$emit('end', this.signaturePad.saveSignature('image/jpeg'))
    }
}
